
module.exports = function() {
    return function(input, wrapper) {

        wrapper =  wrapper.split("");

        var wrapStart = wrapper[0];
        var wrapEnd = wrapper[1];

        return input && input.length > 0 ? wrapStart + input + wrapEnd : "";
    };
};